import {
  DISCOUNT_REQUEST,
  DISCOUNT_SUCCESS,
  DISCOUNT_ERROR,

  DISCOUNT_ADD_REQUEST,
  DISCOUNT_ADD_SUCCESS,
  DISCOUNT_ADD_ERROR,

  DISCOUNT_REMOVE_REQUEST,
  DISCOUNT_REMOVE_SUCCESS,
  DISCOUNT_REMOVE_ERROR,

  DISCOUNT_BLOCK_REQUEST,
  DISCOUNT_BLOCK_SUCCESS,
  DISCOUNT_BLOCK_ERROR,

  DISCOUNT_TRANSACTIONS_REQUEST,
  DISCOUNT_TRANSACTIONS_SUCCESS,
  DISCOUNT_TRANSACTIONS_ERROR,

  DISCOUNT_BONUS_INFO_REQUEST,
  DISCOUNT_BONUS_INFO_SUCCESS,
  DISCOUNT_BONUS_INFO_ERROR,
} from "@/store/actions/discount.js";
import HTTP from "@/utils/http";
import Vue from "vue";
import { AUTH_LOGOUT } from "@/store/actions/auth";

const state = {
  discountCards_get_status: "",
  discountCards_once_loaded: false,
  discountCards: [],

  discountCards_add_status: "",
  discountCards_remove_status: "",
  discountCards_block_status: "",

  discountTransactions_get_status: "",
  discountTransactions_once_loaded: false,
  discountTransactions: [],

  discountBonusInfo_status: "",
  discountBonusInfo_once_loaded: false,
  discountBonusInfo: { balance: 0, card_to_display: null },
};

const getters = {
  getDiscountCards: state => state.discountCards,
  getDiscountCardById: state => id => state.discountCards.find(b => b.id == id),
  isDiscountCardsLoading: state => state.discountCards_get_status === 'loading',
  isDiscountCardsFailed: state => state.discountCards_get_status === 'error',
  discountCardsOnceLoaded: state => state.discountCards_once_loaded,

  getDiscountTransactions: state => state.discountTransactions,
  isDiscountTransactionsLoading: state => state.discountTransactions_get_status === 'loading',
  isDiscountTransactionsFailed: state => state.discountTransactions_get_status === 'error',
  discountTransactionsOnceLoaded: state => state.discountTransactions_once_loaded,

  getDiscountBonusInfo: state => state.discountBonusInfo,
  isDiscountBonusInfoLoading: state => state.discountBonusInfo_status === 'loading',
  isDiscountBonusInfoFailed: state => state.discountBonusInfo_status === 'error',
  discountBonusInfoOnceLoaded: state => state.discountBonusInfo_once_loaded,
};

const actions = {
  [DISCOUNT_REQUEST]: ({ commit, dispatch }) => {
    commit(DISCOUNT_REQUEST);
    HTTP({ url: "discount" })
      .then(resp => {
        commit(DISCOUNT_SUCCESS, resp.data);
      })
      .catch((err) => {
        commit(DISCOUNT_ERROR);
        if (err.status === 401) {
          dispatch(AUTH_LOGOUT);
        }
      });
  },
  [DISCOUNT_ADD_REQUEST]: ({ commit, dispatch }, req) => {
    return new Promise((resolve, reject) => {
      commit(DISCOUNT_ADD_REQUEST);
      HTTP({ url: "discount", data: req, method: "POST" })
        .then(resp => {
          commit(DISCOUNT_ADD_SUCCESS, req);
          resolve(resp);
        })
        .catch(err => {
          commit(DISCOUNT_ADD_ERROR, err);
          if (err.status === 401) {
            dispatch(AUTH_LOGOUT);
          }
          reject(err);
        });
    });
  },
  [DISCOUNT_REMOVE_REQUEST]: ({ commit, dispatch }, req) => {
    return new Promise((resolve, reject) => {
      commit(DISCOUNT_REMOVE_REQUEST);
      HTTP({ url: "discount", data: req, method: "DELETE" })
        .then(resp => {
          commit(DISCOUNT_REMOVE_SUCCESS, req);
          resolve(resp);
        })
        .catch(err => {
          commit(DISCOUNT_REMOVE_ERROR, err);
          if (err.status === 401) {
            dispatch(AUTH_LOGOUT);
          }
          reject(err);
        });
    });
  },
  [DISCOUNT_BLOCK_REQUEST]: ({ commit, dispatch }, req) => {
    return new Promise((resolve, reject) => {
      commit(DISCOUNT_BLOCK_REQUEST);
      HTTP({ url: "discount", data: req, method: "PATCH" })
        .then(resp => {
          commit(DISCOUNT_BLOCK_SUCCESS, req);
          resolve(resp);
        })
        .catch(err => {
          commit(DISCOUNT_BLOCK_ERROR, err);
          if (err.status === 401) {
            dispatch(AUTH_LOGOUT);
          }
          reject(err);
        });
    });
  },

  [DISCOUNT_TRANSACTIONS_REQUEST]: ({ commit, dispatch }) => {
    commit(DISCOUNT_TRANSACTIONS_REQUEST);
    HTTP({ url: "discount/transactions" })
      .then(resp => {
        commit(DISCOUNT_TRANSACTIONS_SUCCESS, resp.data);
      })
      .catch((err) => {
        commit(DISCOUNT_TRANSACTIONS_ERROR);
        if (err.status === 401) {
          dispatch(AUTH_LOGOUT);
        }
      });
  },

  [DISCOUNT_BONUS_INFO_REQUEST]: ({ commit, dispatch }) => {
    commit(DISCOUNT_BONUS_INFO_REQUEST);
    HTTP({ url: "discount/bonus_info" })
      .then(resp => {
        commit(DISCOUNT_BONUS_INFO_SUCCESS, resp.data);
      })
      .catch((err) => {
        commit(DISCOUNT_BONUS_INFO_ERROR);
        if (err.status === 401) {
          dispatch(AUTH_LOGOUT);
        }
      });
  },
};

const mutations = {
  [DISCOUNT_REQUEST]: state => {
    state.discountCards_get_status = "loading";
  },
  [DISCOUNT_SUCCESS]: (state, data) => {
    state.discountCards_get_status = "success";
    Vue.set(state, "discountCards", data);
    state.discountCards_once_loaded = true;
  },
  [DISCOUNT_ERROR]: state => {
    state.discountCards_get_status = "error";
    state.discountCards_once_loaded = true;
  },

  [DISCOUNT_ADD_REQUEST]: state => {
    state.discountCards_add_status = "loading";
  },
  [DISCOUNT_ADD_SUCCESS]: (state, data) => {
    state.discountCards_add_status = "success";
    state.discountCards.push(data);
  },
  [DISCOUNT_ADD_ERROR]: state => {
    state.discountCards_add_status = "error";
  },

  [DISCOUNT_REMOVE_REQUEST]: state => {
    state.discountCards_remove_status = "loading";
  },
  [DISCOUNT_REMOVE_SUCCESS]: (state, data) => {
    state.discountCards_remove_status = "success";
    console.log(state.discountCards);
    console.log(data);
    state.discountCards.splice(state.discountCards.findIndex(d => d.card_id = data.card_id), 1);
  },
  [DISCOUNT_REMOVE_ERROR]: state => {
    state.discountCards_remove_status = "error";
  },

  [DISCOUNT_BLOCK_REQUEST]: state => {
    state.discountCards_remove_status = "loading";
  },
  [DISCOUNT_BLOCK_SUCCESS]: (state, data) => {
    state.discountCards_remove_status = "success";
    let card = state.discountCards
      .splice(state.discountCards.findIndex(d => d.card_id = data.card_id), 1)
      .pop(); //splice() возвращает массив удалённых объектов, так что нужно забрать объект через pop()
    card.block = true;
    state.discountCards.push(card);
  },
  [DISCOUNT_BLOCK_ERROR]: state => {
    state.discountCards_remove_status = "error";
  },

  [DISCOUNT_TRANSACTIONS_REQUEST]: state => {
    state.discountTransactions_get_status = "loading";
  },
  [DISCOUNT_TRANSACTIONS_SUCCESS]: (state, data) => {
    state.discountTransactions_get_status = "success";
    Vue.set(state, "discountTransactions", data);
    state.discountTransactions_once_loaded = true;
  },
  [DISCOUNT_TRANSACTIONS_ERROR]: state => {
    state.discountTransactions_get_status = "error";
    state.discountTransactions_once_loaded = true;
  },

  [DISCOUNT_BONUS_INFO_REQUEST]: state => {
    state.discountBonusInfo_status = "loading";
  },
  [DISCOUNT_BONUS_INFO_SUCCESS]: (state, data) => {
    state.discountBonusInfo_status = "success";
    Vue.set(state, "discountBonusInfo", data);
    state.discountBonusInfo_once_loaded = true;
  },
  [DISCOUNT_BONUS_INFO_ERROR]: state => {
    state.discountBonusInfo_status = "error";
    state.discountBonusInfo_once_loaded = true;
  },

  [AUTH_LOGOUT]: state => {
    state.discountCards_get_status = "";
    state.discountCards_once_loaded = false;
    Vue.set(state, "discountCards", []);
    state.discountCards_add_status = "";
    state.discountCards_remove_status = "";
    state.discountCards_block_status = "";

    state.discountTransactions_get_status = "";
    state.discountTransactions_once_loaded = false;
    Vue.set(state, "discountTransactions", []);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};